$(function () {

    if ('IntersectionObserver' in window) {

        var animatedElements = document.querySelectorAll('.remove2animate, .remove2zoom, .list');

        var animationObserver = new IntersectionObserver(function (animatedElements) {

            for (var i = 0; i < animatedElements.length; i++) {
                var scope = $(animatedElements[i].target);

                if (animatedElements[i]['isIntersecting'] === true) { //when element comes into viewport

                    //bump in sections
                    if (scope.hasClass('remove2animate')) {
                        scope.removeClass('remove2animate');
                    }

                    if (scope.hasClass('remove2zoom')) {
                        scope.removeClass('remove2zoom')
                    }                    

                    //animate list items
                    if (scope.hasClass('list') && !scope.hasClass("zoomOnly")) {
                        scope.addClass('fadeIn');
                    }

                    //animate list items
                    if (scope.hasClass('list') && scope.hasClass("zoomOnly")) {
                        scope.addClass('zoomIn');
                    }

                    //once element is in view, we don't have to observe it anymore
                    animationObserver.unobserve(animatedElements[i].target);
                }
            }

        }, { rootMargin: '-75px' }); //show element when 75px is within viewport

        //init observer on all animatable elements
        for (var i = 0; i < animatedElements.length; i++) {
            animationObserver.observe(animatedElements[i]);
        }

    } else { //if intersectionObserver is not supported in browser, use scroll method for checking when elements come into view

        $(window).scroll(function () {

            var windowBottom = $(window).scrollTop() + $(window).height(),
                animateScrollPoint = $(window).height() * 0.15;            

            $('.remove2animate, ul.halves li, ul.list, remove2zoom').each(function () {                

                if ($(this).offset().top + animateScrollPoint < windowBottom) {

                    //bump in sections
                    if ($(this).hasClass('remove2animate')) {
                        $(this).removeClass('remove2animate');
                    }

                    if (scope.hasClass('remove2zoom')) {
                        scope.removeClass('remove2zoom')
                    }

                    //staggered animation of halves
                    if ($(this).is('ul.halves li')) {
                        $(this).find('.image').removeClass('remove2animate');
                        $(this).find('.info').removeClass('remove2animate');
                    }

                    //animate list items
                    if ($(this).is('ul.list')) {
                        $(this).addClass('fadeIn');
                    }
                }

            });

            //if scroll gets to page bottom, force remove2animate on all remaining elements that still have class.
            //This is required when there is very short content meaning the animateScrollPoint cannot be reached to trigger animation
            if (windowBottom == $(document).height()) {
                $('.remove2animate').removeClass('remove2animate');
                $('.remove2zoom').removeClass('remove2zoom');
            }

        }).scroll();
    }    
})